import parseSearchParams from "@/util/parse-search-params.mjs";

export function queryBaseGQL(
  baseUrl: string,
  query: string,
  variables?: object,
  params?: Record<string, string | object>,
) {
  const searchParams = parseSearchParams({
    query,
    variables,
    ...(params || {}),
  });
  const url = `${baseUrl}?${searchParams}`;
  return url;
}

export function queryGQL(baseURL: string, query: string, variables?: object) {
  return queryBaseGQL(`${baseURL}/graphql`, query, variables);
}

export function postGQL(baseURL: string, query: string, variables: object) {
  return {
    url: `${baseURL}/graphql`,
    body: {
      query,
      variables,
    },
  };
}
